<div class="wrapper">
    <h4 class="main-title">Best Practice</h4>
    <div class="container">
        <!-- initial questions container  -->
        <fieldset class="tab d-block" *ngIf="initialResp && initialResp.current_form == null && initForm">
            <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
                <a (click)="startOver()" href="javascript:void(0);" class="font-weight-bold text-secondary">
                    Start Over <i class="fas fa-undo fa-sm text-dark"></i>
                </a>
                <h6 class="font-weight-bold mb-0 mr-auto">{{initialResp.question}}</h6>
            </div>
            <div class="form-group">
                <p class="mb-2">{{initialResp.question_options.Form_Order}}</p>
                <ul class="list-unstyled mb-0 new-symptoms-list row">
                    <li class="col-md-6 col-xl-4" *ngFor="let item of initialResp.question_options[initialResp.question_options.Form_Order[0]][0].values;let i = index">
                        <div class="custom-control custom-radio">
                            <input class="custom-control-input" (change)="initFormChange($event, i, '')" type="{{initialResp.question_options[initialResp.question_options.Form_Order[0]][0].type}}" 
                            name="exampleRadios" value="{{item}}" id="inlineRadio{{i}}">
                            <label class="custom-control-label" for="inlineRadio{{i}}">
                                {{item}}
                            </label>   
                        </div>  
                    </li>
                </ul>
            </div> 
        </fieldset>
        <!-- follow up question container-->
        <fieldset class="tab" *ngIf="followUpResp[followUpResp.length-1] && followUpResp[followUpResp.length-1].screen == 'form_screen'">
            <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
                <a (click)="startOver()" href="javascript: void(0)" class="font-weight-bold text-secondary">
                    Start Over <i class="fas fa-undo fa-sm text-dark"></i>
                </a>
                <h5 class="font-weight-bold mb-0 mr-auto">{{followUpResp[followUpResp.length-1].question}}</h5>
            </div>
            <div class="form-group" *ngFor="let item of followUpResp[followUpResp.length-1].question_options.Form_Order;let i=index">
                <p class="mb-2">{{item}}</p>
                <ul class="list-unstyled mb-0 new-symptoms-list row">
                    <li class="col-md-6 col-xl-4" *ngIf="followUpResp[followUpResp.length-1].question_options[item][0].values.length == 0 && followUpResp[followUpResp.length-1].question_options[item][0].type == 'textbox'else b">
                        <div class="form-group mb-0"> 
                            <input class="form-control" type="text" (change)="initFormChange($event, i, followUpResp[followUpResp.length-1].question_options.Form_Order.length > 1 ? 'true' : '')"
                            value="{{followUpResp[followUpResp.length-1].question_options[item][0].default_value}}">
                        </div>
                    </li>
                    <ng-template #b>
                        <li class="col-md-6 col-xl-4" 
                        *ngFor="let item1 of followUpResp[followUpResp.length-1].question_options[item][0].values;let ind = index">
                        <div class="custom-control custom-radio">
                            <input name="input{{i}}" class="custom-control-input" (change)="initFormChange($event, i, followUpResp[followUpResp.length-1].question_options.Form_Order.length > 1 ? 'true' : '')"
                            type="{{followUpResp[followUpResp.length-1].question_options[item][0].type}}"
                            value="{{item1}}" id="inlineRadio{{ind}}{{i}}">
                            <label class="custom-control-label" for="inlineRadio{{ind}}{{i}}">
                                {{item1}}
                            </label>
                        </div>
                    </li>
                </ng-template>
            </ul>
        </div> 
    </fieldset>
    <!-- result screen -->
    <fieldset class="tab" *ngIf="followUpResp.length>0 && followUpResp[followUpResp.length-1].no_questions == 0 && followUpResp[followUpResp.length-1].result">   
        <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
            <a (click)="startOver()" href="javascript: void(0)" class="font-weight-bold text-secondary">
                Start Over <i class="fas fa-undo fa-sm text-dark"></i>
            </a>
            <h5 class="font-weight-bold mb-0 mr-auto">Message Board</h5>
        </div>
        <p>
            {{followUpResp[followUpResp.length-1].result.patient_display_summary}}.
        </p> 
    </fieldset> 
    <fieldset class="tab" *ngIf="1 != 1">
        <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
            <a onclick="firstTab(0)" href="javascript: void(0)"  class="font-weight-bold text-secondary">
                Start Over <i class="fas fa-undo fa-sm text-dark"></i>
            </a>
            <h5 class="font-weight-bold mb-0 mr-auto">Imaging Reports</h5>
        </div>
        <div class="form-group">
            <p class="mb-2">Which of these tests are you here for?</p>
            <ul class="list-unstyled mb-0 new-symptoms-list row">
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="xray">
                        <label class="custom-control-label" for="xray">
                            X-ray
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="ctscan">
                        <label class="custom-control-label" for="ctscan">
                            CT-Scan
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="petscan">
                        <label class="custom-control-label" for="petscan">
                            PET Scan
                        </label>
                    </div>
                </li>  
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="colonoscopy">
                        <label class="custom-control-label" for="colonoscopy">
                            Colonoscopy
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="other">
                        <label class="custom-control-label" for="other">
                            Other
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="ultrasound">
                        <label class="custom-control-label" for="ultrasound">
                            Ultra-Sound
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="mri">
                        <label class="custom-control-label" for="mri">
                            MRI
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="endoscopy">
                        <label class="custom-control-label" for="endoscopy">
                            Endoscopy
                        </label>
                    </div>
                </li>
                <li class="col-md-6 col-xl-4">
                    <div class="custom-control custom-radio">
                        <input class="custom-control-input" type="radio" name="exampleRadios" value="" id="Mammogram">
                        <label class="custom-control-label" for="Mammogram">
                            Mammogram
                        </label>
                    </div>
                </li>
            </ul>
        </div> 
    </fieldset>
    <fieldset class="tab" *ngIf="1 != 1">   
        <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
            <a onclick="firstTab(0)" href="javascript: void(0)"  class="font-weight-bold text-secondary">
                Start Over <i class="fas fa-undo fa-sm text-dark"></i>
            </a>
            <h5 class="font-weight-bold mb-0 mr-auto">Surgical Clearance</h5>
        </div>
        <div class="form-group">
            <p class="mb-2">Name of planned Surgery</p>
            <div class="row">
                <div class="col-md-6 col-xl-4">
                    <div class="form-group mb-0"> 
                        <input type="text" placeholder=""  class="form-control">
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <p class="mb-2">Have you had any surgery in the past</p>  
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="exampleRadios" id="surgeryYes" value="option1" checked="">
                <label class="custom-control-label" for="surgeryYes">
                    Yes
                </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="exampleRadios" id="surgeryNo" value="option2">
                <label class="custom-control-label" for="surgeryNo">
                    No
                </label>
            </div>
        </div>
        
    </fieldset>
    <fieldset class="tab" *ngIf="1 != 1">
        <div class="align-items-center d-flex flex-row-reverse flex-wrap mb-2 section-heading">
            <a onclick="firstTab(0)" href="javascript: void(0)" class="font-weight-bold text-secondary">
                Start Over <i class="fas fa-undo fa-sm text-dark"></i>
            </a>
            <h5 class="font-weight-bold mb-0 mr-auto">Medication / Prescription / Shots</h5>
        </div>
        <div class="form-group">
            <p class="mb-2">Have you experienced any side effects of current medications?</p>  
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="medicationsYes" id="medicationsYes" value="option1" checked="">
                <label class="custom-control-label" for="medicationsYes">
                    Yes
                </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="medicationsYes" id="medicationsNo" value="option2">
                <label class="custom-control-label" for="medicationsNo">
                    No
                </label>
            </div>
        </div>  
        <div class="form-group">
            <p class="mb-2">Are you here for Medication refill</p>  
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="refillYes" id="refillYes" value="option1" checked="">
                <label class="custom-control-label" for="refillYes">
                    Yes
                </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" type="radio" name="refillYes" id="refillNo" value="option2">
                <label class="custom-control-label" for="refillNo">
                    No
                </label>
            </div>
        </div>
    </fieldset>
    
</div>
</div>

<footer class="p-3">
    <div class="container p-0">
        <div class="d-flex justify-content-between align-items-center">
            <button class="btn btn-outline-primary" type="button">Back</button>
            <p class="mb-0">(4 of 7)</p>
            <button *ngIf="lastStep" class="btn btn-primary" type="button" (click)="finish()" href="javascript: void(0)">Finish</button>
            <button *ngIf="!lastStep" class="btn btn-primary" type="button" (click)="nextClicked(initialResp.current_form)" href="javascript: void(0)">Next</button>
        </div>
    </div>
</footer>

<!-- Symptoms Modal -->
<div class="modal fade" id="Symptoms-Modal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Please Select a Part</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
            </div>
            <div class="modal-body select-symptoms">
                <ul class="list-unstyled symptoms-list">
                    <li class="pt-0">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios1" value="option3" checked>
                            <label class="custom-control-label" for="exampleRadios1"> Head </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios2" value="option3">
                            <label class="custom-control-label" for="exampleRadios2"> Nose </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios3" value="option3">
                            <label class="custom-control-label" for="exampleRadios3"> Mouth </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios4" value="option3">
                            <label class="custom-control-label" for="exampleRadios4"> Face </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios5" value="option3">
                            <label class="custom-control-label" for="exampleRadios5"> Skin </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios6" value="option3">
                            <label class="custom-control-label" for="exampleRadios6"> Ear </label>
                        </div>
                    </li>
                    <li>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input class="custom-control-input" type="radio" name="exampleRadios2" id="exampleRadios7" value="option3">
                            <label class="custom-control-label" for="exampleRadios7"> Eye </label>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary " data-dismiss="modal">Close</button> 
                <button type="button" data-toggle="modal" data-target="#Select-Symptoms-Modal" class="btn btn-primary ">Add</button> </div>
            </div>
        </div>
    </div>
    <!-- Select any of the following  -->
    <div class="modal fade" id="Select-Symptoms-Modal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Select Any Of The Following Symptoms</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body symptoms-modal">
                    <div class="input-group mb-3">
                        <input type="text" class="form-control rounded" placeholder="Search symptoms">
                        <div class="search-icon">
                            <i class="fas fa-search text-gray"></i>
                        </div>
                    </div>
                    <ul class="list-unstyled symptoms-list">
                        <li>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck11">
                                <label class="custom-control-label" for="customCheck11"> Anxiety
                                    <span class="d-block symptoms-part">Head</span>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck12">
                                <label class="custom-control-label" for="customCheck12">Depression
                                    <span class="d-block symptoms-part">Head</span>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck13">
                                <label class="custom-control-label" for="customCheck13">Dizziness
                                    <span class="d-block symptoms-part">Head</span>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck14">
                                <label class="custom-control-label" for="customCheck14">Headache
                                    <span class="d-block symptoms-part">Head</span>
                                </label>
                            </div>
                        </li>
                        <li>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck15">
                                <label class="custom-control-label" for="customCheck15">Inability To Sleep<span
                                    class="d-block symptoms-part">Head</span></label>
                                </div>
                            </li>
                            <li>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck16">
                                    <label class="custom-control-label" for="customCheck16">Loss Of Consciousness<span
                                        class="d-block symptoms-part">Head</span></label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary " data-dismiss="modal">Close</button>
                            <button type="button" href="Screen-7.html" class="btn btn-primary ">Finish Selection</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Symptoms Modal -->
            <div class="modal fade" id="Cant-find-Symptoms-Modal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Select or Search any of the following symptoms</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
                        </div>
                        <div class="modal-body symptoms-modal">
                            <div class="input-group mb-3">
                                <input type="text" class="form-control rounded" value="Chest" placeholder="Search symptoms">
                                <div class="search-icon"> <i class="fas fa-search text-gray"></i> </div>
                            </div>
                            <div class="d-flex flex-wrap select-symptoms mb-3">
                                <div class="select-item">
                                    <div class="add-symptom">
                                        <p class="mb-0">Pressure</p> <span class="small">Chest</span> </div> <span><i class="cursor-pointer delete fa-times fas ml-3 fa-lg text-danger"></i></span> </div>
                                        <div class="select-item">
                                            <div class="add-symptom">
                                                <p class="mb-0">Fullness</p> <span class="small">Chest</span> </div> <span><i class="cursor-pointer delete fa-times fas ml-3 fa-lg text-danger"></i></span> </div>
                                            </div>
                                            <ul class="list-unstyled symptoms-list">
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck115">
                                                        <label class="custom-control-label" for="customCheck115"> Pressure<span class="d-block symptoms-part">Chest</span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck116">
                                                        <label class="custom-control-label" for="customCheck116">Fullness<span class="d-block symptoms-part">Chest</span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck117">
                                                        <label class="custom-control-label" for="customCheck117">Burning<span class="d-block symptoms-part">Chest
                                                        </span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck118">
                                                        <label class="custom-control-label" for="customCheck118">Tightness<span class="d-block symptoms-part">Chest</span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck19">
                                                        <label class="custom-control-label" for="customCheck19">Pain<span class="d-block symptoms-part">Chest</span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck20">
                                                        <label class="custom-control-label" for="customCheck20"> Pressure<span class="d-block symptoms-part">Chest</span></label>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="custom-control custom-checkbox">
                                                        <input type="checkbox" class="custom-control-input" id="customCheck21">
                                                        <label class="custom-control-label" for="customCheck21">Fullness<span class="d-block symptoms-part">Chest <i class="fas fa-arrow-right fa-sm text-muted"></i>
                                                            Weakness</span></label>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <div class="custom-control custom-checkbox">
                                                            <input type="checkbox" class="custom-control-input" id="customCheck22">
                                                            <label class="custom-control-label" for="customCheck22">Burning<span class="d-block symptoms-part">Chest
                                                                <i class="fas fa-arrow-right fa-sm text-muted"></i> Weakness</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div class="custom-control custom-checkbox">
                                                                <input type="checkbox" class="custom-control-input" id="customCheck23">
                                                                <label class="custom-control-label" for="customCheck23">Tightness<span class="d-block symptoms-part">Chest <i class="fas fa-arrow-right fa-sm text-muted"></i>
                                                                    Weakness</span></label>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="custom-control custom-checkbox">
                                                                    <input type="checkbox" class="custom-control-input" id="customCheck24">
                                                                    <label class="custom-control-label" for="customCheck24">Pain<span class="d-block symptoms-part">Chest <i
                                                                        class="fas fa-arrow-right fa-sm text-muted"></i> Weakness</span></label>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div class="modal-footer">
                                                            <button type="button" class="btn btn-outline-primary " data-dismiss="modal">Close</button> 
                                                            <button type="button" href="Screen-7.html" class="btn btn-primary ">Add</button> 
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>